import React, { useState, useMemo } from 'react';
import css from './FilterSidebar.module.css';
import { createFilterOptions } from '../../../util/genericHelpers';
import { FieldConfigKey } from '../../../util/enums';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';

const EthnicityFilterSection = ({
  paramKey,
  handleClearFilter,
  handleCheckboxChange,
  userFields,
  selectedValues = [],
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const ethnicityKeyConfig = userFields.find(f => f.key === FieldConfigKey.ETHNICITY) || {};
  const ethnicityFilterOptions = createFilterOptions(ethnicityKeyConfig.enumOptions) || [];

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  const filteredOptions = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return ethnicityFilterOptions.filter(opt => opt.label.toLowerCase().includes(term));
  }, [searchTerm, ethnicityFilterOptions]);

  return (
    <div className={css.filterSection}>
      <FilterSectionHeader titleId="FilterCategories.ethnicity" handleClear={handleClear} />

      <SearchInput
        placeholder="Search Ethnicity..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />

      <div className={css.scrollable}>
        {filteredOptions.map(opt => {
          const isChecked = selectedValues.includes(opt.value.toLowerCase());
          return (
            <label key={opt.value} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={opt.value.toLowerCase()}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
              />
              <span>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default EthnicityFilterSection;
